import "@github/include-fragment-element"

addEventListener("loadstart", setAcceptHeader, { capture: true })

function setAcceptHeader({ target }) {
  if (target.localName == "include-fragment") {
    target.accept = "text/html; fragment"
  }
}
